import { Injectable } from '@angular/core';

import { AuthenticationService } from '../authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService  {

  constructor(public auth: AuthenticationService) { }

  async canActivate(): Promise<boolean> {
    await this.auth.ready;
    return this.auth.isAuthenticated();
  }
}
